import { List, Map } from "immutable";
import { createSelector } from "reselect";

// dimensions
export const getAppWidth = (state) => state.app.getIn(["appMeasurements", "width"]);
export const getAppHeight = (state) => state.app.getIn(["appMeasurements", "height"]);
export const getIsMobileView = (state) => state.app.getIn(["isMobileView"], false);

// app information
export const getAppConfig = (state) => state.app;
export const getIsDebug = (state) => getAppConfig(state).get("debug", false);

// user information
export const getUser = (state) => state.app.get("user", Map());
export const getUserName = (state) => state.app.getIn(["user", "name"], null);
export const getUserID = (state) => getUser(state).get("id");
export const getUserEmail = (state) => getUser(state).get("email");
export const getUserPermissionType = (state) => getUser(state).get("permissionType");
export const getUserDirectReportsCount = (state) => getUser(state).get("directReportsCount", 0);

export const getUserIsAdmin = (state) => getUser(state).get("isAdmin", false);
export const getUserIsBasicAdmin = (state) => getUser(state).get("permissionType", "") === "basic-admins";
export const getUserCanManagerEmployees = (state) => getUserIsAdmin(state);

// user settings
export const selectUserTimezone = (state, notSetValue) => state.app.getIn(["userSettings", "timezone"], notSetValue);

// get company id
export const getUserCompanyID = (state) => getUser(state).getIn(["company", "id"], null);

// get company name
export const getUserCompanyName = (state) => getUser(state).getIn(["company", "name"], null);

// get company microsoft teams tenant_id
export const getCompanyMicrosoftTenantID = (state) => getUser(state).getIn(["company"], null);

// user aliases
const userAliasesSelector = (state) => state.app.getIn(["userAliases"], List());

// alphabetically sorted user aliases
export const selectUserAliases = createSelector(userAliasesSelector, (aliases) => {
	const sortedAliases = aliases.sort((a, b) => {
		const aName = a.get("name", "z").toLowerCase();
		const bName = b.get("name", "z").toLowerCase();

		if (aName < bName) {
			return -1;
		}
		if (aName > bName) {
			return 1;
		}
		return 0;
	});

	return sortedAliases;
});

export const selectUserAliasCount = (state) => selectUserAliases(state).size;
export const selectUserDefaultCompanyID = (state) => state.app.getIn(["userDefaultAlias"], null);

export const getUserInvitationStatus = createSelector([getUser], () => {
	const responses = ["signedIn", "receivedInvitationNeverSignedIn", "neverReceivedInvitation"];
	return responses[0];
});

export const getIsUserSuperuser = createSelector([getUser], (user) => user.get("isSuperuser", false));

export const feedbackRequestEnabled = (state) =>
	state.app.getIn(["features", "feedback", "allowRequestFeedback"], false);
